import type { OSIndicator } from '@/lib/os-indicator';

// Cor partilhada por contexto (lista e perfil). Estados "ativos" piscam;
// terminais (concluida/cancelada) mostram glifo ✓/✕ estático.
const COR_ATIVO: Partial<Record<NonNullable<OSIndicator>, string>> = {
  em_execucao: 'os-led--exec',
  aceita: 'os-led--aceita',
  disponivel: 'os-led--disp',
};

interface OSAvatarIndicatorProps {
  osIndicador?: OSIndicator | null;
  /** Classe de geometria/posição do contexto (ex: 'cli-itm__led' ou 'painel__profile-led'). */
  ledClassName: string;
}

/**
 * Bolinha no avatar do cliente que reflete a OS mais ativa. Partilhado entre a
 * coluna da lista (ClienteListItem) e a coluna do perfil (ClienteProfile) para
 * a aparência (cor/pulse/glifo) ser única; só a geometria varia por contexto.
 */
export function OSAvatarIndicator({ osIndicador, ledClassName }: OSAvatarIndicatorProps) {
  if (!osIndicador) return null;

  const corAtivo = COR_ATIVO[osIndicador];
  if (corAtivo) {
    return <span className={`${ledClassName} os-led--pulse ${corAtivo}`} aria-hidden />;
  }

  const glifo = osIndicador === 'concluida' ? '✓' : '✕';
  return (
    <span className={`${ledClassName} os-led--glifo`} aria-hidden>
      {glifo}
    </span>
  );
}
